<browse-user-playlists-table *ngIf="isTableMode; else tiles" [playlists]="playlists" [userId]="userId">
</browse-user-playlists-table>

<ng-template #tiles>
	<browse-user-playlists-tiles [playlists]="playlists" [userId]="userId">
	</browse-user-playlists-tiles>
</ng-template>
